module.exports = __webpack_public_path__ + "img/resource-2.10289cc1.png";